import { replace } from 'react-router-redux';

import {
    apiGetVolunteerOpportunities,
    apiCompleteVolunteerSignup
} from '../../utils/volunteer/volunteerApi';

import { formatVolunteerFormData } from '../../utils/volunteer/helpers';

import { onGoToNextCard, onFinishMultiAction } from '../Widget/actions';

export const IS_BACK_TRANSITION = 'IS_BACK_TRANSITION';
export const SET_ACTIVE_ACTION = 'SET_ACTIVE_ACTION';
export const VOLUNTEER_INITIATED = 'VOLUNTEER_INITIATED';
export const VOLUNTEER_CANCELED = 'VOLUNTEER_CANCELED';
export const VOLUNTEER_COMPLETED = 'VOLUNTEER_COMPLETED';
export const TOGGLE_LOCATION_FORM_POPUP = 'TOGGLE_LOCATION_FORM_POPUP';
export const TOGGLE_LOCATION_FORM_SUBMITTING = 'TOGGLE_LOCATION_FORM_SUBMITTING';
export const VOLUNTEER_OPPORTUNITIES_LOADING = 'VOLUNTEER_OPPORTUNITIES_LOADING';
export const SET_VOLUNTEER_OPPORTUNITIES = 'SET_VOLUNTEER_OPPORTUNITIES';
export const SET_SELECTED_VOLUNTEER_OPPORTUNITY = 'SET_SELECTED_VOLUNTEER_OPPORTUNITY';
export const POSTAL_CODE_POPUP_SUBMITTING = 'POSTAL_CODE_POPUP_SUBMITTING';
export const VOLUNTEER_SIGNUP_FORM_SUBMITTING = 'VOLUNTEER_SIGNUP_FORM_SUBMITTING';
export const SET_SUCCESS_INFO = 'SET_SUCCESS_INFO';
export const SET_ON_PRELOAD_SCREEN = 'SET_ON_PRELOAD_SCREEN';
export const SET_LOCATION = 'SET_LOCATION';

export const manuallySetUserLocation = location => dispatch => {
    dispatch({
        type: SET_LOCATION,
        payload: location
    });
};

export const onSubmitVolunteerForm = (
    volunteerOpportunity,
    volunteerFormData,
    apiRequestData,
    actionCompletedTime,
    isMultiCard,
    actionIdentifier,
    skipEndCard
) => dispatch => {
    dispatch({
        type: VOLUNTEER_SIGNUP_FORM_SUBMITTING,
        payload: true
    });

    const formattedAnswers = formatVolunteerFormData(
        volunteerOpportunity,
        volunteerFormData
    );

    const requestData = {
        ...apiRequestData,
        opportunityId: volunteerOpportunity.id,
        opportunityName: volunteerOpportunity.title,
        email: volunteerFormData.email,
        firstName: volunteerFormData.firstName,
        lastName: volunteerFormData.lastName,
        phoneNumber: volunteerFormData.phone,
        country: volunteerFormData.countryCode,
        zipCode: volunteerFormData.postalCode,
        answers: formattedAnswers,
        comments: volunteerFormData.message || '',
        notifyResult: true,
        actionCompletedTime
    };

    return apiCompleteVolunteerSignup(requestData)
        .then(data => {
            dispatch({
                type: VOLUNTEER_COMPLETED,
                payload: {
                    data,
                    actionIdentifier: [actionIdentifier]
                }
            });

            if (isMultiCard) {
                onFinishMultiAction(actionIdentifier)(dispatch);
            } else if (!skipEndCard) {
                dispatch(replace(`/volunteer/success`));
            }

            setTimeout(() => {
                dispatch({
                    type: VOLUNTEER_SIGNUP_FORM_SUBMITTING,
                    payload: false
                });
            }, 1000);
        })
        .catch(e => {
            dispatch({
                type: VOLUNTEER_SIGNUP_FORM_SUBMITTING,
                payload: false
            });
            console.error(e);
        });
};

export const onSelectVolunteerOpportunity = (
    index,
    volunteerOpportunities
) => dispatch => {
    dispatch({
        type: SET_SELECTED_VOLUNTEER_OPPORTUNITY,
        payload: volunteerOpportunities[index]
    });
    dispatch(replace(`/volunteer/step1`));
};

export const onGoToStep = (currStep, nextStep) => dispatch => {
    let isBackTransition = currStep > nextStep;

    if (isBackTransition) {
        dispatch({
            type: IS_BACK_TRANSITION,
            payload: isBackTransition
        });
    } else {
        dispatch({
            type: VOLUNTEER_SIGNUP_FORM_SUBMITTING,
            payload: true
        });
    }

    if (nextStep === 0) {
        dispatch(replace('/volunteer'));
    } else {
        dispatch(replace(`/volunteer/step${nextStep}`));
    }

    setTimeout(() => {
        dispatch({
            type: VOLUNTEER_SIGNUP_FORM_SUBMITTING,
            payload: false
        });
        if (isBackTransition) {
            dispatch({
                type: IS_BACK_TRANSITION,
                payload: false
            });
        }
    }, 1000);
};

export const fetchVolunteerOpportunities = (
    postalCode,
    countryCode,
    volunteerId,
    actionIdentifier,
    onPreloadScreen,
    fetchedFromPopupForm,
    useOnlyCache
) => dispatch => {
    if (fetchedFromPopupForm) {
        dispatch({
            type: TOGGLE_LOCATION_FORM_SUBMITTING,
            payload: true
        });
    }
    dispatch({
        type: TOGGLE_LOCATION_FORM_POPUP,
        payload: false
    });

    dispatch({
        type: VOLUNTEER_OPPORTUNITIES_LOADING,
        payload: true
    });

    let foundData = false;

    if (onPreloadScreen && !useOnlyCache) {
        onGoToNextCard(actionIdentifier, 'volunteer', false, false, false, true)(
            dispatch
        );
        dispatch({
            type: SET_ON_PRELOAD_SCREEN,
            payload: false
        });
    }

    return apiGetVolunteerOpportunities(
        postalCode,
        countryCode,
        volunteerId,
        useOnlyCache
    )
        .then(data => {
            foundData = data && data.length;
            if (foundData || !useOnlyCache) {
                dispatch({
                    type: SET_VOLUNTEER_OPPORTUNITIES,
                    payload: data
                });
            }
        })
        .then(() => {
            if (fetchedFromPopupForm) {
                dispatch({
                    type: TOGGLE_LOCATION_FORM_SUBMITTING,
                    payload: false
                });
            }

            if (foundData && onPreloadScreen && useOnlyCache) {
                dispatch({
                    type: SET_ON_PRELOAD_SCREEN,
                    payload: false
                });
                onGoToNextCard(actionIdentifier, 'volunteer', false, false, false, true)(
                    dispatch
                );
            }
            dispatch({
                type: VOLUNTEER_OPPORTUNITIES_LOADING,
                payload: false
            });
        })
        .catch(e => {
            console.error(e);
        });
};

export const onDetailsContainerClick = (
    actionIdentifier,
    actionInitiated
) => dispatch => {
    if (!actionInitiated) {
        dispatch({
            type: VOLUNTEER_INITIATED,
            payload: actionIdentifier
        });
    }
};

export const onInitiateVolunteerAction = (
    actionIdentifier,
    actionInitiated
) => dispatch => {
    dispatch({
        type: SET_ACTIVE_ACTION,
        payload: { actionIdentifier }
    });
    if (!actionInitiated) {
        dispatch({
            type: VOLUNTEER_INITIATED,
            payload: actionIdentifier
        });
    }
};

export const onShowLocationChangePopup = (
    value,
    actionIdentifier,
    actionInitiated
) => dispatch => {
    dispatch({
        type: TOGGLE_LOCATION_FORM_POPUP,
        payload: value
    });
    if (!actionInitiated) {
        dispatch({
            type: VOLUNTEER_INITIATED,
            payload: actionIdentifier
        });
    }
    if (actionIdentifier) {
        dispatch({
            type: SET_ACTIVE_ACTION,
            payload: { actionIdentifier }
        });
    }

    if (!value) {
        dispatch({
            type: VOLUNTEER_CANCELED,
            payload: actionIdentifier
        });
    }
};



// WEBPACK FOOTER //
// ./src/containers/Volunteer/actions.js